'use strict';

module.exports = function (ngModule) {
    ngModule.directive('datePicker', require('./datepicker'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/datepicker/index.js
 **/